import axios from "@/axios/axios";
import qs from "qs";

export default {
  namespaced: true,
  actions: {
    requestServiceByKeyword(context, payload) {
      return axios
        .post("/api/service/getList", null, {
          params: {
            searchText: payload.searchText,
            currentPage: payload.currentPage,
            perPage: payload.perPage,
            sortBy: payload.sortBy,
            sortDesc: payload.sortDesc,
            categories: "",
          },
        })
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    requestCorpServiceByKeyword(context, payload) {
      return axios
        .post("/api/corp/service/getList", null, {
          params: {
            searchText: payload.searchText,
            currentPage: payload.currentPage,
            perPage: payload.perPage,
            sortBy: payload.sortBy,
            sortDesc: payload.sortDesc,
            status: payload.status,
            categories: "",
          },
        })
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    requestCorpServiceByCategoryNameList(context, payload) {
      return axios
        .post("/api/corp/service/getList", null, {
          params: {
            searchText: "",
            currentPage: payload.currentPage,
            perPage: payload.perPage,
            sortBy: payload.sortBy,
            sortDesc: payload.sortDesc,
            status: "",
            categories: payload.categoryNameList,
          },
        })
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    requestServiceDetail(context, payload) {
      return axios
        .post("/api/service/getDetail", null, {
          params: {
            idx: payload.idx,
            status: payload.status,
          },
        })
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    saveService(context, payload) {
      const formData = new FormData();
      formData.append("idx", payload.idx);
      formData.append("categoryList", JSON.stringify(payload.categoryList));
      formData.append("manufacture", payload.manufacture);
      formData.append("file0", payload.file0);
      formData.append("file1", payload.file1);
      formData.append("file2", payload.file2);
      formData.append("file3", payload.file3);
      formData.append("file4", payload.file4);
      formData.append("file5", payload.file5);
      formData.append("name", payload.name);
      formData.append("company", payload.company);
      formData.append("price", payload.price);
      formData.append("link", payload.link);
      formData.append("desc", payload.desc);
      formData.append("detail", payload.detail);
      formData.append(
        "additionalItemDataList",
        JSON.stringify(payload.additionalItemDataList)
      );
      formData.append("deleteFileList", JSON.stringify(payload.deleteFileList));

      return axios
        .post("/api/corp/service/save", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    requestCorpServiceDetail(context, idx) {
      return axios
        .post("/api/corp/service/getDetail", null, {
          params: {
            idx: idx,
          },
        })
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    deleteService(context, idxList) {
      return axios
        .get("/api/corp/service/delete", {
          params: {
            idxList: idxList,
          },
          paramsSerializer: (params) => {
            return qs.stringify(params, { arrayFormat: "repeat" });
          },
        })
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    requestServiceBySubCategory(context, payload) {
      return axios
        .post("/api/service/getList/bySubCategory", null, {
          params: {
            currentPage: payload.currentPage,
            perPage: payload.perPage,
            sortBy: payload.sortBy,
            sortDesc: payload.sortDesc,
            status: payload.status,
            targetIdx: payload.targetIdx,
            categories: payload.categories,
          },
        })
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    createComment(context, payload) {
      payload.type = "service";
      return axios
        .post("/api/comments", payload)
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    getComments(context, idx) {
      return axios
        .get("/api/comments/service/" + idx)
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    deleteComments(context, idx) {
      return axios
        .delete("/api/comments/" + idx)
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    updateComments(context, payload) {
      return axios
        .patch("/api/comments/" + payload.idx, {
          content: payload.content,
        })
        .then((response) => {
          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
  },
};
